/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: any;
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: any;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']>;
  contentType_contains?: InputMaybe<Scalars['String']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not?: InputMaybe<Scalars['String']>;
  contentType_not_contains?: InputMaybe<Scalars['String']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileName_contains?: InputMaybe<Scalars['String']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not?: InputMaybe<Scalars['String']>;
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  size_exists?: InputMaybe<Scalars['Boolean']>;
  size_gt?: InputMaybe<Scalars['Int']>;
  size_gte?: InputMaybe<Scalars['Int']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt?: InputMaybe<Scalars['Int']>;
  size_lte?: InputMaybe<Scalars['Int']>;
  size_not?: InputMaybe<Scalars['Int']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  downloadCollection?: Maybe<DownloadCollection>;
  entryCollection?: Maybe<EntryCollection>;
  powersOfAttorneyCollection?: Maybe<PowersOfAttorneyCollection>;
  preislisteCollection?: Maybe<PreislisteCollection>;
};


export type AssetLinkingCollectionsDownloadCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsPowersOfAttorneyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsPreislisteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/download) */
export type Download = Entry & _Node & {
  __typename?: 'Download';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  file?: Maybe<Asset>;
  header?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<DownloadLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/download) */
export type DownloadFileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/download) */
export type DownloadHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/download) */
export type DownloadLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DownloadCollection = {
  __typename?: 'DownloadCollection';
  items: Array<Maybe<Download>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type DownloadFilter = {
  AND?: InputMaybe<Array<InputMaybe<DownloadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DownloadFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  file_exists?: InputMaybe<Scalars['Boolean']>;
  header?: InputMaybe<Scalars['String']>;
  header_contains?: InputMaybe<Scalars['String']>;
  header_exists?: InputMaybe<Scalars['Boolean']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header_not?: InputMaybe<Scalars['String']>;
  header_not_contains?: InputMaybe<Scalars['String']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type DownloadLinkingCollections = {
  __typename?: 'DownloadLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type DownloadLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum DownloadOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/faqQuestion) */
export type FaqQuestion = Entry & _Node & {
  __typename?: 'FaqQuestion';
  _id: Scalars['ID'];
  awnser?: Maybe<FaqQuestionAwnser>;
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<FaqQuestionLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/faqQuestion) */
export type FaqQuestionAwnserArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/faqQuestion) */
export type FaqQuestionHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/faqQuestion) */
export type FaqQuestionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FaqQuestionAwnser = {
  __typename?: 'FaqQuestionAwnser';
  json: Scalars['JSON'];
  links: FaqQuestionAwnserLinks;
};

export type FaqQuestionAwnserAssets = {
  __typename?: 'FaqQuestionAwnserAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FaqQuestionAwnserEntries = {
  __typename?: 'FaqQuestionAwnserEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FaqQuestionAwnserLinks = {
  __typename?: 'FaqQuestionAwnserLinks';
  assets: FaqQuestionAwnserAssets;
  entries: FaqQuestionAwnserEntries;
  resources: FaqQuestionAwnserResources;
};

export type FaqQuestionAwnserResources = {
  __typename?: 'FaqQuestionAwnserResources';
  block: Array<FaqQuestionAwnserResourcesBlock>;
  hyperlink: Array<FaqQuestionAwnserResourcesHyperlink>;
  inline: Array<FaqQuestionAwnserResourcesInline>;
};

export type FaqQuestionAwnserResourcesBlock = ResourceLink & {
  __typename?: 'FaqQuestionAwnserResourcesBlock';
  sys: ResourceSys;
};

export type FaqQuestionAwnserResourcesHyperlink = ResourceLink & {
  __typename?: 'FaqQuestionAwnserResourcesHyperlink';
  sys: ResourceSys;
};

export type FaqQuestionAwnserResourcesInline = ResourceLink & {
  __typename?: 'FaqQuestionAwnserResourcesInline';
  sys: ResourceSys;
};

export type FaqQuestionCollection = {
  __typename?: 'FaqQuestionCollection';
  items: Array<Maybe<FaqQuestion>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FaqQuestionFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqQuestionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqQuestionFilter>>>;
  awnser_contains?: InputMaybe<Scalars['String']>;
  awnser_exists?: InputMaybe<Scalars['Boolean']>;
  awnser_not_contains?: InputMaybe<Scalars['String']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']>;
  header_contains?: InputMaybe<Scalars['String']>;
  header_exists?: InputMaybe<Scalars['Boolean']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header_not?: InputMaybe<Scalars['String']>;
  header_not_contains?: InputMaybe<Scalars['String']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FaqQuestionLinkingCollections = {
  __typename?: 'FaqQuestionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type FaqQuestionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FaqQuestionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']>;
};

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/jobOffer) */
export type JobOffer = Entry & _Node & {
  __typename?: 'JobOffer';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<JobOfferLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/jobOffer) */
export type JobOfferDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/jobOffer) */
export type JobOfferHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/jobOffer) */
export type JobOfferLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type JobOfferCollection = {
  __typename?: 'JobOfferCollection';
  items: Array<Maybe<JobOffer>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type JobOfferFilter = {
  AND?: InputMaybe<Array<InputMaybe<JobOfferFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<JobOfferFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header?: InputMaybe<Scalars['String']>;
  header_contains?: InputMaybe<Scalars['String']>;
  header_exists?: InputMaybe<Scalars['Boolean']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header_not?: InputMaybe<Scalars['String']>;
  header_not_contains?: InputMaybe<Scalars['String']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type JobOfferLinkingCollections = {
  __typename?: 'JobOfferLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type JobOfferLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum JobOfferOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/notification) */
export type Notification = Entry & _Node & {
  __typename?: 'Notification';
  _id: Scalars['ID'];
  activeUntil?: Maybe<Scalars['DateTime']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<NotificationLinkingCollections>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/notification) */
export type NotificationActiveUntilArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/notification) */
export type NotificationDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/notification) */
export type NotificationHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/notification) */
export type NotificationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/notification) */
export type NotificationTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NotificationCollection = {
  __typename?: 'NotificationCollection';
  items: Array<Maybe<Notification>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NotificationFilter = {
  AND?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
  activeUntil?: InputMaybe<Scalars['DateTime']>;
  activeUntil_exists?: InputMaybe<Scalars['Boolean']>;
  activeUntil_gt?: InputMaybe<Scalars['DateTime']>;
  activeUntil_gte?: InputMaybe<Scalars['DateTime']>;
  activeUntil_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  activeUntil_lt?: InputMaybe<Scalars['DateTime']>;
  activeUntil_lte?: InputMaybe<Scalars['DateTime']>;
  activeUntil_not?: InputMaybe<Scalars['DateTime']>;
  activeUntil_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header?: InputMaybe<Scalars['String']>;
  header_contains?: InputMaybe<Scalars['String']>;
  header_exists?: InputMaybe<Scalars['Boolean']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header_not?: InputMaybe<Scalars['String']>;
  header_not_contains?: InputMaybe<Scalars['String']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NotificationLinkingCollections = {
  __typename?: 'NotificationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type NotificationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NotificationOrder {
  ActiveUntilAsc = 'activeUntil_ASC',
  ActiveUntilDesc = 'activeUntil_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/openingHours) */
export type OpeningHours = Entry & _Node & {
  __typename?: 'OpeningHours';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  index?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<OpeningHoursLinkingCollections>;
  openingHours?: Maybe<Scalars['String']>;
  sys: Sys;
  weekday?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/openingHours) */
export type OpeningHoursIndexArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/openingHours) */
export type OpeningHoursLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/openingHours) */
export type OpeningHoursOpeningHoursArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/openingHours) */
export type OpeningHoursWeekdayArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type OpeningHoursCollection = {
  __typename?: 'OpeningHoursCollection';
  items: Array<Maybe<OpeningHours>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type OpeningHoursFilter = {
  AND?: InputMaybe<Array<InputMaybe<OpeningHoursFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OpeningHoursFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  index?: InputMaybe<Scalars['Int']>;
  index_exists?: InputMaybe<Scalars['Boolean']>;
  index_gt?: InputMaybe<Scalars['Int']>;
  index_gte?: InputMaybe<Scalars['Int']>;
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  index_lt?: InputMaybe<Scalars['Int']>;
  index_lte?: InputMaybe<Scalars['Int']>;
  index_not?: InputMaybe<Scalars['Int']>;
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  openingHours?: InputMaybe<Scalars['String']>;
  openingHours_contains?: InputMaybe<Scalars['String']>;
  openingHours_exists?: InputMaybe<Scalars['Boolean']>;
  openingHours_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  openingHours_not?: InputMaybe<Scalars['String']>;
  openingHours_not_contains?: InputMaybe<Scalars['String']>;
  openingHours_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  weekday?: InputMaybe<Scalars['String']>;
  weekday_contains?: InputMaybe<Scalars['String']>;
  weekday_exists?: InputMaybe<Scalars['Boolean']>;
  weekday_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weekday_not?: InputMaybe<Scalars['String']>;
  weekday_not_contains?: InputMaybe<Scalars['String']>;
  weekday_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpeningHoursLinkingCollections = {
  __typename?: 'OpeningHoursLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type OpeningHoursLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum OpeningHoursOrder {
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  OpeningHoursAsc = 'openingHours_ASC',
  OpeningHoursDesc = 'openingHours_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  WeekdayAsc = 'weekday_ASC',
  WeekdayDesc = 'weekday_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/powersOfAttorney) */
export type PowersOfAttorney = Entry & _Node & {
  __typename?: 'PowersOfAttorney';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  file?: Maybe<Asset>;
  linkedFrom?: Maybe<PowersOfAttorneyLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/powersOfAttorney) */
export type PowersOfAttorneyFileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/powersOfAttorney) */
export type PowersOfAttorneyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/powersOfAttorney) */
export type PowersOfAttorneyTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type PowersOfAttorneyCollection = {
  __typename?: 'PowersOfAttorneyCollection';
  items: Array<Maybe<PowersOfAttorney>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PowersOfAttorneyFilter = {
  AND?: InputMaybe<Array<InputMaybe<PowersOfAttorneyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PowersOfAttorneyFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  file_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PowersOfAttorneyLinkingCollections = {
  __typename?: 'PowersOfAttorneyLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type PowersOfAttorneyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum PowersOfAttorneyOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/preisliste) */
export type Preisliste = Entry & _Node & {
  __typename?: 'Preisliste';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  file?: Maybe<Asset>;
  linkedFrom?: Maybe<PreislisteLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/preisliste) */
export type PreislisteFileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/preisliste) */
export type PreislisteLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/preisliste) */
export type PreislisteTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type PreislisteCollection = {
  __typename?: 'PreislisteCollection';
  items: Array<Maybe<Preisliste>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PreislisteFilter = {
  AND?: InputMaybe<Array<InputMaybe<PreislisteFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PreislisteFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  file_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PreislisteLinkingCollections = {
  __typename?: 'PreislisteLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type PreislisteLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum PreislisteOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/productOffer) */
export type ProductOffer = Entry & _Node & {
  __typename?: 'ProductOffer';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ProductOfferLinkingCollections>;
  price?: Maybe<Scalars['Int']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/productOffer) */
export type ProductOfferHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/productOffer) */
export type ProductOfferLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/productOffer) */
export type ProductOfferPriceArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ProductOfferCollection = {
  __typename?: 'ProductOfferCollection';
  items: Array<Maybe<ProductOffer>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductOfferFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductOfferFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductOfferFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']>;
  header_contains?: InputMaybe<Scalars['String']>;
  header_exists?: InputMaybe<Scalars['Boolean']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header_not?: InputMaybe<Scalars['String']>;
  header_not_contains?: InputMaybe<Scalars['String']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  price?: InputMaybe<Scalars['Int']>;
  price_exists?: InputMaybe<Scalars['Boolean']>;
  price_gt?: InputMaybe<Scalars['Int']>;
  price_gte?: InputMaybe<Scalars['Int']>;
  price_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  price_lt?: InputMaybe<Scalars['Int']>;
  price_lte?: InputMaybe<Scalars['Int']>;
  price_not?: InputMaybe<Scalars['Int']>;
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductOfferLinkingCollections = {
  __typename?: 'ProductOfferLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ProductOfferLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ProductOfferOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  download?: Maybe<Download>;
  downloadCollection?: Maybe<DownloadCollection>;
  entryCollection?: Maybe<EntryCollection>;
  faqQuestion?: Maybe<FaqQuestion>;
  faqQuestionCollection?: Maybe<FaqQuestionCollection>;
  jobOffer?: Maybe<JobOffer>;
  jobOfferCollection?: Maybe<JobOfferCollection>;
  notification?: Maybe<Notification>;
  notificationCollection?: Maybe<NotificationCollection>;
  openingHours?: Maybe<OpeningHours>;
  openingHoursCollection?: Maybe<OpeningHoursCollection>;
  powersOfAttorney?: Maybe<PowersOfAttorney>;
  powersOfAttorneyCollection?: Maybe<PowersOfAttorneyCollection>;
  preisliste?: Maybe<Preisliste>;
  preislisteCollection?: Maybe<PreislisteCollection>;
  productOffer?: Maybe<ProductOffer>;
  productOfferCollection?: Maybe<ProductOfferCollection>;
  serviceOffer?: Maybe<ServiceOffer>;
  serviceOfferCollection?: Maybe<ServiceOfferCollection>;
  serviceOfferDetails?: Maybe<ServiceOfferDetails>;
  serviceOfferDetailsCollection?: Maybe<ServiceOfferDetailsCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryDownloadArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDownloadCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<DownloadOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DownloadFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryFaqQuestionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFaqQuestionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FaqQuestionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqQuestionFilter>;
};


export type QueryJobOfferArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryJobOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<JobOfferOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<JobOfferFilter>;
};


export type QueryNotificationArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNotificationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NotificationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationFilter>;
};


export type QueryOpeningHoursArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOpeningHoursCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<OpeningHoursOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OpeningHoursFilter>;
};


export type QueryPowersOfAttorneyArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPowersOfAttorneyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PowersOfAttorneyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PowersOfAttorneyFilter>;
};


export type QueryPreislisteArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPreislisteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PreislisteOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PreislisteFilter>;
};


export type QueryProductOfferArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductOfferOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductOfferFilter>;
};


export type QueryServiceOfferArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryServiceOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ServiceOfferOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceOfferFilter>;
};


export type QueryServiceOfferDetailsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryServiceOfferDetailsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ServiceOfferDetailsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceOfferDetailsFilter>;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String'];
  urn: Scalars['String'];
};

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOffer) */
export type ServiceOffer = Entry & _Node & {
  __typename?: 'ServiceOffer';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Entry>;
  header?: Maybe<Scalars['String']>;
  highlighted?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ServiceOfferLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOffer) */
export type ServiceOfferDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOffer) */
export type ServiceOfferDetailsArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOffer) */
export type ServiceOfferHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOffer) */
export type ServiceOfferHighlightedArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOffer) */
export type ServiceOfferLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ServiceOfferCollection = {
  __typename?: 'ServiceOfferCollection';
  items: Array<Maybe<ServiceOffer>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetails = Entry & _Node & {
  __typename?: 'ServiceOfferDetails';
  _id: Scalars['ID'];
  addonFees?: Maybe<Array<Maybe<Scalars['String']>>>;
  checklist?: Maybe<Array<Maybe<Scalars['String']>>>;
  checklistAdmissionSheetLost?: Maybe<Array<Maybe<Scalars['String']>>>;
  checklistImportVehicles?: Maybe<Array<Maybe<Scalars['String']>>>;
  checklistLostLicensePlate?: Maybe<Array<Maybe<Scalars['String']>>>;
  commercialChecklist?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  downloadsCollection?: Maybe<ServiceOfferDetailsDownloadsCollection>;
  header?: Maybe<Scalars['String']>;
  includedServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  infobox?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ServiceOfferDetailsLinkingCollections>;
  newCarChecklist?: Maybe<Array<Maybe<Scalars['String']>>>;
  prices?: Maybe<Array<Maybe<Scalars['String']>>>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsAddonFeesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsChecklistArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsChecklistAdmissionSheetLostArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsChecklistImportVehiclesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsChecklistLostLicensePlateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsCommercialChecklistArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsDownloadsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsIncludedServicesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsInfoboxArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsNewCarChecklistArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/x5sf0ntqjneh/content_types/serviceOfferDetails) */
export type ServiceOfferDetailsPricesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ServiceOfferDetailsCollection = {
  __typename?: 'ServiceOfferDetailsCollection';
  items: Array<Maybe<ServiceOfferDetails>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ServiceOfferDetailsDownloadsCollection = {
  __typename?: 'ServiceOfferDetailsDownloadsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ServiceOfferDetailsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceOfferDetailsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceOfferDetailsFilter>>>;
  addonFees_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addonFees_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addonFees_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addonFees_exists?: InputMaybe<Scalars['Boolean']>;
  checklistAdmissionSheetLost_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistAdmissionSheetLost_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistAdmissionSheetLost_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistAdmissionSheetLost_exists?: InputMaybe<Scalars['Boolean']>;
  checklistImportVehicles_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistImportVehicles_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistImportVehicles_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistImportVehicles_exists?: InputMaybe<Scalars['Boolean']>;
  checklistLostLicensePlate_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistLostLicensePlate_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistLostLicensePlate_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistLostLicensePlate_exists?: InputMaybe<Scalars['Boolean']>;
  checklist_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklist_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklist_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklist_exists?: InputMaybe<Scalars['Boolean']>;
  commercialChecklist_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  commercialChecklist_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  commercialChecklist_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  commercialChecklist_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  downloadsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  header?: InputMaybe<Scalars['String']>;
  header_contains?: InputMaybe<Scalars['String']>;
  header_exists?: InputMaybe<Scalars['Boolean']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header_not?: InputMaybe<Scalars['String']>;
  header_not_contains?: InputMaybe<Scalars['String']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedServices_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedServices_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedServices_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedServices_exists?: InputMaybe<Scalars['Boolean']>;
  infobox?: InputMaybe<Scalars['String']>;
  infobox_contains?: InputMaybe<Scalars['String']>;
  infobox_exists?: InputMaybe<Scalars['Boolean']>;
  infobox_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  infobox_not?: InputMaybe<Scalars['String']>;
  infobox_not_contains?: InputMaybe<Scalars['String']>;
  infobox_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newCarChecklist_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newCarChecklist_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newCarChecklist_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newCarChecklist_exists?: InputMaybe<Scalars['Boolean']>;
  prices_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prices_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prices_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prices_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type ServiceOfferDetailsLinkingCollections = {
  __typename?: 'ServiceOfferDetailsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ServiceOfferDetailsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ServiceOfferDetailsOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ServiceOfferFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceOfferFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceOfferFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  details_exists?: InputMaybe<Scalars['Boolean']>;
  header?: InputMaybe<Scalars['String']>;
  header_contains?: InputMaybe<Scalars['String']>;
  header_exists?: InputMaybe<Scalars['Boolean']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  header_not?: InputMaybe<Scalars['String']>;
  header_not_contains?: InputMaybe<Scalars['String']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  highlighted?: InputMaybe<Scalars['String']>;
  highlighted_contains?: InputMaybe<Scalars['String']>;
  highlighted_exists?: InputMaybe<Scalars['Boolean']>;
  highlighted_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  highlighted_not?: InputMaybe<Scalars['String']>;
  highlighted_not_contains?: InputMaybe<Scalars['String']>;
  highlighted_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ServiceOfferLinkingCollections = {
  __typename?: 'ServiceOfferLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ServiceOfferLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ServiceOfferOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HighlightedAsc = 'highlighted_ASC',
  HighlightedDesc = 'highlighted_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']>;
};

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte?: InputMaybe<Scalars['String']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte?: InputMaybe<Scalars['DateTime']>;
};

export type _Node = {
  _id: Scalars['ID'];
};

export type DownloadCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadCollectionQuery = { __typename?: 'Query', downloadCollection?: { __typename?: 'DownloadCollection', items: Array<{ __typename?: 'Download', header?: string | null, file?: { __typename?: 'Asset', title?: string | null, description?: string | null, url?: string | null, fileName?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type DownloadEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DownloadEntryQuery = { __typename?: 'Query', download?: { __typename?: 'Download', header?: string | null, file?: { __typename?: 'Asset', title?: string | null, description?: string | null, url?: string | null, fileName?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type FaqQuestionCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqQuestionCollectionQuery = { __typename?: 'Query', faqQuestionCollection?: { __typename?: 'FaqQuestionCollection', items: Array<{ __typename?: 'FaqQuestion', header?: string | null, sys: { __typename?: 'Sys', id: string }, awnser?: { __typename?: 'FaqQuestionAwnser', json: any } | null } | null> } | null };

export type JobOfferCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type JobOfferCollectionQuery = { __typename?: 'Query', jobOfferCollection?: { __typename?: 'JobOfferCollection', items: Array<{ __typename?: 'JobOffer', header?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type NotificationCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationCollectionQuery = { __typename?: 'Query', notificationCollection?: { __typename?: 'NotificationCollection', items: Array<{ __typename?: 'Notification', description?: string | null, activeUntil?: any | null, header?: string | null, type?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type OpeningHoursCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type OpeningHoursCollectionQuery = { __typename?: 'Query', openingHoursCollection?: { __typename?: 'OpeningHoursCollection', items: Array<{ __typename?: 'OpeningHours', weekday?: string | null, index?: number | null, openingHours?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type PowersOfAttorneyCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PowersOfAttorneyCollectionQuery = { __typename?: 'Query', powersOfAttorneyCollection?: { __typename?: 'PowersOfAttorneyCollection', items: Array<{ __typename?: 'PowersOfAttorney', title?: string | null, file?: { __typename?: 'Asset', title?: string | null, description?: string | null, url?: string | null, fileName?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type PowersOfAttorneyEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PowersOfAttorneyEntryQuery = { __typename?: 'Query', powersOfAttorney?: { __typename?: 'PowersOfAttorney', title?: string | null, file?: { __typename?: 'Asset', title?: string | null, description?: string | null, url?: string | null, fileName?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type PricelistCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PricelistCollectionQuery = { __typename?: 'Query', preislisteCollection?: { __typename?: 'PreislisteCollection', items: Array<{ __typename?: 'Preisliste', title?: string | null, file?: { __typename?: 'Asset', title?: string | null, description?: string | null, url?: string | null, fileName?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type PricelistEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PricelistEntryQuery = { __typename?: 'Query', preisliste?: { __typename?: 'Preisliste', title?: string | null, file?: { __typename?: 'Asset', title?: string | null, description?: string | null, url?: string | null, fileName?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type ProductOfferCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductOfferCollectionQuery = { __typename?: 'Query', productOfferCollection?: { __typename?: 'ProductOfferCollection', items: Array<{ __typename?: 'ProductOffer', header?: string | null, price?: number | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type ServiceOfferDetailsEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ServiceOfferDetailsEntryQuery = { __typename?: 'Query', serviceOfferDetails?: { __typename?: 'ServiceOfferDetails', header?: string | null, prices?: Array<string | null> | null, addonFees?: Array<string | null> | null, includedServices?: Array<string | null> | null, description?: string | null, infobox?: string | null, checklist?: Array<string | null> | null, commercialChecklist?: Array<string | null> | null, newCarChecklist?: Array<string | null> | null, checklistImportVehicles?: Array<string | null> | null, checklistAdmissionSheetLost?: Array<string | null> | null, checklistLostLicensePlate?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, downloadsCollection?: { __typename?: 'ServiceOfferDetailsDownloadsCollection', items: Array<{ __typename?: 'Download', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FaqQuestion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JobOffer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Notification', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'OpeningHours', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PowersOfAttorney', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Preisliste', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductOffer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ServiceOffer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ServiceOfferDetails', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null };

export type ServiceOfferCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceOfferCollectionQuery = { __typename?: 'Query', serviceOfferCollection?: { __typename?: 'ServiceOfferCollection', items: Array<{ __typename?: 'ServiceOffer', header?: string | null, description?: string | null, highlighted?: string | null, sys: { __typename?: 'Sys', id: string }, details?: { __typename?: 'Download', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FaqQuestion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JobOffer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Notification', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'OpeningHours', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PowersOfAttorney', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Preisliste', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductOffer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ServiceOffer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ServiceOfferDetails', sys: { __typename?: 'Sys', id: string } } | null } | null> } | null };


export const DownloadCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"header_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DownloadCollectionQuery, DownloadCollectionQueryVariables>;
export const DownloadEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DownloadEntryQuery, DownloadEntryQueryVariables>;
export const FaqQuestionCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"faqQuestionCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faqQuestionCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"header_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"awnser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FaqQuestionCollectionQuery, FaqQuestionCollectionQueryVariables>;
export const JobOfferCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"jobOfferCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobOfferCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<JobOfferCollectionQuery, JobOfferCollectionQueryVariables>;
export const NotificationCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notificationCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedVersion_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activeUntil"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationCollectionQuery, NotificationCollectionQueryVariables>;
export const OpeningHoursCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"openingHoursCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openingHoursCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"7"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"index_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpeningHoursCollectionQuery, OpeningHoursCollectionQueryVariables>;
export const PowersOfAttorneyCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"powersOfAttorneyCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"powersOfAttorneyCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"title_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PowersOfAttorneyCollectionQuery, PowersOfAttorneyCollectionQueryVariables>;
export const PowersOfAttorneyEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"powersOfAttorneyEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"powersOfAttorney"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PowersOfAttorneyEntryQuery, PowersOfAttorneyEntryQueryVariables>;
export const PricelistCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pricelistCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preislisteCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"title_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PricelistCollectionQuery, PricelistCollectionQueryVariables>;
export const PricelistEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pricelistEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preisliste"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PricelistEntryQuery, PricelistEntryQueryVariables>;
export const ProductOfferCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productOfferCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productOfferCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"header_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductOfferCollectionQuery, ProductOfferCollectionQueryVariables>;
export const ServiceOfferDetailsEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"serviceOfferDetailsEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceOfferDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"prices"}},{"kind":"Field","name":{"kind":"Name","value":"addonFees"}},{"kind":"Field","name":{"kind":"Name","value":"includedServices"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"infobox"}},{"kind":"Field","name":{"kind":"Name","value":"downloadsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"commercialChecklist"}},{"kind":"Field","name":{"kind":"Name","value":"newCarChecklist"}},{"kind":"Field","name":{"kind":"Name","value":"checklistImportVehicles"}},{"kind":"Field","name":{"kind":"Name","value":"checklistAdmissionSheetLost"}},{"kind":"Field","name":{"kind":"Name","value":"checklistLostLicensePlate"}}]}}]}}]} as unknown as DocumentNode<ServiceOfferDetailsEntryQuery, ServiceOfferDetailsEntryQueryVariables>;
export const ServiceOfferCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"serviceOfferCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceOfferCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"header_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"highlighted"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ServiceOfferCollectionQuery, ServiceOfferCollectionQueryVariables>;